import { globalDisplayQueue } from "keno/app/modules/DisplayQueue";
/**
 * View class responsible for showing the passed in message list
 * one after the other
 *
 * @param object[] An array of messages as returned from the backend UniNavMessages class
 */
const UniNavMessagesView = {
	/**
	 * Show the messages one after the other
	 *
	 * @param object[] Messages list to show as returned by the UniNavMessages backend class
	 *
	 * @return Promise a promise that will resolve once the last message has been shown and closed
	 */
	show: function ( messages ) {
		globalDisplayQueue.enqueue(() => {
			return window.PCH.uninav.controller.showMessage( messages );
		});
	}
};

export default UniNavMessagesView;
